import { useEffect, useState, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { terms, refund } from 'app/libs/hsTermsInfo';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

import * as Terms from 'app/statics/hs/Terms';
import * as Contract from 'app/statics/hs/Contract';
import * as Refund from 'app/statics/hs/Refund';
import * as Privacy from 'app/statics/hs/Privacy';
import * as Consignment from 'app/statics/hs/Consignment';

import * as RefundWarranty from 'app/statics/hs/RefundWarranty';
import * as PrivacyWarranty from 'app/statics/hs/PrivacyWarranty';
import * as Provide from 'app/statics/hs/Provide';

const componentMap = {
	Terms,
	Contract,
	Refund,
	Privacy,
	Consignment,
	RefundWarranty,
	PrivacyWarranty,
	Provide,
};

const encarURL = process.env.REACT_APP_ENCAR_MOBILE;

export default function useTerms(isRefund = false, targetType = '') {
	const ua = useSsrUserAgent();
	const [index, setIndex] = useState(0);
	const [component, setComponent] = useState(null);

	const { pathname, search } = useLocation();
	const history = useHistory();
	const { version } = queryString.parse(search);
	const data = isRefund ? refund : terms;

	const closeTerms = useCallback(() => {
		const { isApp } = ua();
		if (isApp) {
			window.self.close();
		} else {
			history.goBack();
		}
	}, [history, ua]);

	const getComponent = useCallback(async (componentName, componentVersion) => {
		const Component = componentMap[componentName][`${componentName}_${componentVersion}`];
		if (Component) {
			setComponent(Component);
		} else {
			alert('잘못된 접근입니다.');
			window.location.href = encarURL;
		}
	}, []);

	useEffect(() => {
		let type = '';
		const typeFromPath = pathname.split('/')[2];
		if (targetType === '') {
			type = typeFromPath;
		} else if (targetType === 'optionalPrivacy') {
			type = 'privacy';
		} else {
			type = targetType;
		}
		const { componentIndex, componentName, deploy } = data[type];
		const recentVersion = deploy.map((item) => item.ver).reduce((acc, cur) => Math.max(acc, cur), 0);
		const recentVersionStr = recentVersion < 10 ? `0${recentVersion}` : `${recentVersion}`;
		const resultVersion = version || recentVersionStr;
		setIndex(componentIndex);
		getComponent(componentName, resultVersion);
	}, [data, pathname, version, getComponent, targetType]);

	return {
		index,
		component,
		closeTerms,
	};
}
